import React from 'react'

import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md'
import { useTheme } from 'styled-components'

import { useSharedDates } from '@contexts/sharedDates'
import { useDate } from '@hooks/dates'

import { DateSelectorView, SelectorTitle } from './styles'

interface IProps {
  format?: 'dateShort' | 'dateLong' | 'dateMonthYear' | 'weekRange'
}

export function DateSelector({ format = 'weekRange' }: IProps) {
  const { selectedDate, setSelectedDate } = useSharedDates()
  const { moveForward, moveBackward, getWeekRange, formatDate, formatRange } =
    useDate()
  const theme = useTheme()

  const { weekStart, weekEnd } = getWeekRange(selectedDate)

  const moveWeekBackward = () =>
    setSelectedDate(moveBackward(selectedDate, { weeks: 1 }))
  const moveWeekForward = () =>
    setSelectedDate(moveForward(selectedDate, { weeks: 1 }))

  return (
    <DateSelectorView>
      <button
        onClick={moveWeekBackward}
        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
      >
        <MdNavigateBefore size={30} color={theme.colors.info} />
      </button>
      <div>
        {format === 'weekRange' ? (
          <SelectorTitle>{`${formatRange(weekStart, weekEnd)}`}</SelectorTitle>
        ) : (
          <SelectorTitle>{formatDate(selectedDate)[format]}</SelectorTitle>
        )}
      </div>
      <button
        onClick={moveWeekForward}
        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
      >
        <MdNavigateNext size={30} color={theme.colors.info} />
      </button>
    </DateSelectorView>
  )
}
